import { FormPassengersValues } from 'entities/ticket/models/form-passengers'

import { BuyTicketApi } from 'shared/api/BuyTicket'
import { BuyTicket } from 'shared/api/BuyTicketModel'
import { TicketInsurance } from 'shared/api/avia/insurance'
import { sourceAggregator } from 'shared/constants'
import { preparePhoneNumberForRequest } from 'shared/lib/prepare-phone-number'
import { TicketItem } from 'shared/models/ticket'
import { trackAdjustEvent } from 'shared/services/adjust'

import { getPurchasePassenger } from './preparePurchaseForm'

interface Props {
  selectedTicket: TicketItem | null
  formPassengers: FormPassengersValues | null
  selectedInsurances: TicketInsurance[] | null
}

export const onGetTicketFirstTouchFn = async ({
  formPassengers,
  selectedTicket,
  selectedInsurances,
}: Props) => {
  const passengersPurchasePrepared = getPurchasePassenger(formPassengers)

  const preparedData: BuyTicket = {
    uid: selectedTicket!.uid,
    it_ref: selectedTicket!.it_ref,
    tid: String(selectedTicket?.tid),
    route_code: selectedTicket!.route_code,
    passengers: passengersPurchasePrepared,
    price: String(selectedTicket?.price?.KGS),
    insurance_tariffs: selectedInsurances || [],
    source: selectedTicket?.source as sourceAggregator,
    segments_direction: selectedTicket?.segments_direction,
    flight_promo_discount_id: selectedTicket?.flight_promo_discount_id,
    phone_number:
      preparePhoneNumberForRequest(formPassengers?.phone_number) || '',
  }

  if (formPassengers?.email) preparedData.email = formPassengers.email

  const response = await BuyTicketApi.buyTicket(preparedData)
  const bookingId = response.data?.data?.id

  if (bookingId) void trackAdjustEvent('aviaBooking', bookingId)

  return response
}
